import {
  init,
  replayIntegration,
  browserTracingIntegration,
  tanstackRouterBrowserTracingIntegration,
} from '@sentry/react';
import { router } from '../router';

const integrations = [
  browserTracingIntegration({
    traceFetch: false,
  }),
  tanstackRouterBrowserTracingIntegration(router),
];

if (__NODA__) {
  integrations.push(
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  );
}

init({
  dsn: __SENTRY_DSN__,
  // debug: true,
  enabled: import.meta.env.PROD,
  release: __APP_VERSION__ ?? 'development',
  environment: __APP_ENVIRONMENT__ ?? 'development',
  replaysSessionSampleRate: __NODA__ ? 0.25 : 0.0,
  replaysOnErrorSampleRate: __NODA__ ? 1.0 : 0.0,

  tracesSampleRate: 0.5,
  tracePropagationTargets: [__B2B_API_URL__],
  profilesSampleRate: 0.5,

  integrations,
});
